import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import VueI18n from "vue-i18n";

Vue.use(Vuetify);
Vue.use(VueI18n);

// Translation provided by Vuetify (typescript)
import fr from "vuetify/src/locale/fr.ts";
import en from "vuetify/src/locale/en.ts";

// Fichier de style
import "../assets/styles/main.css";

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg" // "mdi" || "mdiSvg" || "md" || "fa" || "fa4" || "faSvg"
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: "#e64415",
        secondary: "#d3edee", //"#333333"
        accent: "#496277", // former primary
        error: "#f2a18a",
        info: "#67bbbd",
        success: "#02a18a", // #aeb835
        warning: "#fd8321",
        grey: "#f3f3f3",
        orange: "#ffefe5",
        white: "#ffffff"
      }
    }
  },
  lang: {
    locales: { fr, en },
    current: "fr"
  }
});
